'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setCurrentTime;

var _deprecationWarning = require('../deprecationWarning');

var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);

var _setCurrentTimeMs = require('./setCurrentTimeMs');

var _setCurrentTimeMs2 = _interopRequireDefault(_setCurrentTimeMs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This function works out the time for the clip playing and the virtual time
 * that is represented on the progress bar. Takes an options parameter:
 *
 * - forClip: boolean - Whether the time is for a certain clip
 * - skipVideoUpdate: boolean - Whether we should not tell the video it's changing
 */
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SetCurrentTime
 * @deprecated
 */

function setCurrentTime(currentTime) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  (0, _deprecationWarning2.default)('"setCurrentTime" has been renamed to "setCurrentTimeMs" and expects values in ms.');

  (0, _setCurrentTimeMs2.default)(currentTime * 1000, options);
}
module.exports = exports['default'];